import { render } from "./PurchaseOrder.vue?vue&type=template&id=5b14fd92&scoped=true"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js"

import "./PurchaseOrder.vue?vue&type=style&index=0&id=5b14fd92&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b14fd92"]])

export default __exports__